<template>
      <Stats></Stats>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("@/firebaseConfig.js");

export default {
  data: () => ({
    school: null,
    stab: null,
    collectionName: "students",
    title: "Students",
  }),
  components: {
    Stats: () => import("./Stats"),
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    yyschool() {
      return fb.yyschool;
    },
  },
  created() {
  },
  methods: {
   
  },
};
</script>
